<template>
    <cmpsloganfullpage :linkspiegazioni="'#spiegazioni'"></cmpsloganfullpage>
    <cmpspiegazioni></cmpspiegazioni>
    <cmpdivider></cmpdivider>
    <cmpcustomers></cmpcustomers>
    <cmpfooter :sticktobottom="false"></cmpfooter>
</template>

<script>

import multilangmixin from "../mixins/multilangmixin.js"

import cmpsloganfullpage from "../components/cmpsloganfullpage.vue"
import cmpspiegazioni from "../components/cmpspiegazioni.vue"
import cmpdivider from "../components/cmpdivider.vue"
import cmpcustomers from "../components/cmpcustomers.vue"
import cmpfooter from "../components/cmpfooter.vue"






export default {
  name: "homepage",
  mixins:[multilangmixin],
  components:{
    cmpsloganfullpage,
    cmpspiegazioni,
    cmpdivider,
    cmpcustomers,
    cmpfooter
    
  },
  props:{
      "lang":String
  },

  created(){
    
  },

}



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
